import { OrgTreeHelper } from '../../../../backend/features/organizations/OrganizationTreeHelper';
import { getOrganizationTreeFunctionDef } from '../../../../backend/features/organizations/shared';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
export const getOrganizationTree = implementTypedPlatformFunction(getOrganizationTreeFunctionDef, (context, request) => {
    return new OrgTreeHelper(context).getOrganizationsTree(request);
});
